import { render } from "./rwx-network.vue?vue&type=template&id=5d818224"
import script from "./rwx-network.vue?vue&type=script&lang=js"
export * from "./rwx-network.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__